import { render, staticRenderFns } from "./IncidentReportModal.vue?vue&type=template&id=19c5dc3b&scoped=true"
import script from "./IncidentReportModal.vue?vue&type=script&lang=js"
export * from "./IncidentReportModal.vue?vue&type=script&lang=js"
import style0 from "./IncidentReportModal.vue?vue&type=style&index=0&id=19c5dc3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5dc3b",
  null
  
)

export default component.exports